import { createContext, useContext, useState, useEffect } from "react";
import PropTypes from "prop-types";
import axios from "../lib/axios";

const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    // Check if user is logged in on mount
    const token = localStorage.getItem("token");
    if (token) {
      fetchUserData();
    } else {
      setLoading(false);
    }
  }, []);

  const fetchUserData = async () => {
    try {
      const { data } = await axios.get("/auth/me");
      setUser(data);
    } catch (err) {
      console.error("Error fetching user data:", err);
      localStorage.removeItem("token");
    }
    setLoading(false);
  };

  const login = async (email, password) => {
    try {
      const { data } = await axios.post("/auth/login", {
        email,
        password,
      });
      localStorage.setItem("token", data.token);
      await fetchUserData();
      return { success: true };
    } catch (err) {
      return {
        success: false,
        error: err.response?.data?.message || "An error occurred during login",
      };
    }
  };

  const logout = () => {
    localStorage.removeItem("token");
    setUser(null);
  };

  return (
    <AuthContext.Provider value={{ user, login, logout, loading }}>
      {children}
    </AuthContext.Provider>
  );
};

AuthProvider.propTypes = {
  children: PropTypes.node.isRequired,
};

export const useAuth = () => {
  const context = useContext(AuthContext);
  if (!context) {
    throw new Error("useAuth must be used within an AuthProvider");
  }
  return context;
};
